import { FC, MouseEvent } from 'react'
import Typography from '@/ui/components/typography'
import { CustomTooltip } from '@atbay/component-lib'
import CopyIcon from '@/assets/images/copy-icon.svg?react'
import { useCopyWithFeedback } from '@/ui/components/caseNumberDisplay/useCopyWithFeedback'
import {
    CaseNumberIconWrapper,
    CaseNumberRow,
} from './CaseNumberDisplay.styles'
import { TFontVariant } from '@/core/theme'

export interface CaseNumberDisplayProps {
    caseNumber: string
    iconSize?: { width: number; height: number }
    typographyVariant?: TFontVariant
    showFull?: boolean
}

const CaseNumberDisplay: FC<CaseNumberDisplayProps> = ({
    caseNumber,
    iconSize = { width: 13, height: 15 },
    typographyVariant = 'xs-regular',
    showFull = false,
}) => {
    const [copied, copyToClipboard] = useCopyWithFeedback()
    const displayCaseNumber = caseNumber
        ? showFull
            ? caseNumber
            : `${caseNumber.slice(0, 6)}...`
        : ''

    const handleCopy = () => {
        if (caseNumber) {
            copyToClipboard(caseNumber)
        }
    }
    return (
        <CustomTooltip
            title={copied ? 'Copied!' : caseNumber}
            placement="top"
            alwaysShowOnHover
        >
            <CaseNumberRow>
                <Typography
                    component="span"
                    variant={typographyVariant}
                    className="table-cell-text"
                >
                    {displayCaseNumber}
                </Typography>
                {caseNumber && (
                    <CaseNumberIconWrapper onClick={handleCopy}>
                        <CopyIcon
                            width={iconSize.width}
                            height={iconSize.height}
                            role="img"
                        />
                    </CaseNumberIconWrapper>
                )}
            </CaseNumberRow>
        </CustomTooltip>
    )
}

export default CaseNumberDisplay
